import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Collapse, Typography } from "@mui/material";
import {
  MyLeaveEmailByCompanyForm,
  MyLeaveEmailForm,
} from "my-leave/components";
import { OcCard, OcFormSwitch } from "oc/components";
import { useOcProperty } from "oc/hooks";

interface MyLeaveEmailCardProps {
  type: "administrativeEmail" | "payrollEmail";
  isMobile: boolean;
}

export const MyLeaveEmailCard = ({ type, isMobile }: MyLeaveEmailCardProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const [emailByCompanyState, setEmailByCompanyState] = useState<
    boolean | undefined
  >(undefined);

  const { data: emailByCompany } = useOcProperty({
    resource: "myLeave",
    key:
      type === "administrativeEmail"
        ? "administrativeEmailByCompany"
        : "payrollEmailByCompany",
    onCompleted: ({ value }) => {
      if (!emailByCompanyState && value) {
        const newState = value === "true" ? true : false;
        setEmailByCompanyState(newState);
      }
    },
  });

  let cardLabel =
    type === "administrativeEmail"
      ? t("MY_LEAVE_ADMINISTRATIVE_EMAIL")
      : t("MY_LEAVE_SUBSEQUENT_REQUESTS");

  let infoText =
    type === "administrativeEmail"
      ? t("MY_LEAVE_ADMINISTRATIVE_EMAIL_INFO_TEXT")
      : t("MY_LEAVE_PAYROLL_EMAIL_INFO_TEXT");

  return (
    <OcCard label={cardLabel} loading={loading}>
      <Box padding="24px 0px 0px 0px">
        <Box
          letterSpacing="0.44px"
          color="#4d4d4d"
          fontSize="16px"
          paddingLeft="16px"
        >
          {infoText}
        </Box>
        <Box height="36px" />
        <Box>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            paddingLeft="16px"
          >
            <OcFormSwitch
              checked={emailByCompanyState || false}
              inputProps={{ "aria-label": "controlled" }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setEmailByCompanyState(e.target.checked)
              }
              disabled={loading}
            />
            <Box width="16px" />
            <Typography variant="caption">
              {t("MY_LEAVE_SEPARATE_EMAIL_COMPANY")}
            </Typography>
          </Box>
          <Box height="24px" />
          <Collapse
            in={emailByCompanyState || false}
            timeout="auto"
            unmountOnExit
          >
            <MyLeaveEmailByCompanyForm
              type={type}
              setLoading={setLoading}
              emailByCompanyState={emailByCompanyState ?? false}
              emailByCompany={emailByCompany === "true" ? true : false}
              isMobile={isMobile}
            />
          </Collapse>
          <Collapse in={!emailByCompanyState || false} timeout="auto">
            <MyLeaveEmailForm
              setLoading={setLoading}
              type={type}
              emailByCompanyState={emailByCompanyState ?? false}
              emailByCompany={emailByCompany === "true" ? true : false}
              isMobile={isMobile}
            />
          </Collapse>
        </Box>
      </Box>
    </OcCard>
  );
};

export default MyLeaveEmailCard;
